import React from "react";
import { useTranslation } from "react-i18next";
import { Chat } from "./common/Chat";
import { Footer } from "./common/Footer";
import { Header } from "./common/Header";
import { LbLoader } from "./simple/LbLoader";
import { NavBar } from "./simple/NavBar";

export const Layout = ({ children, navBar = false }) => {
  const { ready } = useTranslation("Common");
  if (!ready)
    return (
      <h1 className="text-center">
        <LbLoader inCenter={true} isLoading={true} />
      </h1>
    );

  return (
    <>
      <Header />
      {navBar && <NavBar />}
      {children}
      <Footer />
      {/* <Chat /> */}
    </>
  );
};
